import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/AppContext';
import { CSpinner, CAlert } from '@coreui/react';
import FormCompany from '../../components/FormCompany/FormCompany';

const EditCompanyForAdmin = () => {
    const { companyId } = useParams(); // Obtiene :companyId de la URL
    const navigate = useNavigate();
    const { getCompanyById, updateCompany } = React.useContext(AppContext);
    
    const [companyData, setCompanyData] = useState(null);
    const [loadingData, setLoadingData] = useState(true);
    const [errorData, setErrorData] = useState(null);

    const handleUpdateCompany = async (data) => {
        await updateCompany(companyId, data);
    };

    useEffect(() => {
        const fetchCompany = async () => {
            try {
                const response = await getCompanyById(companyId);
                const apiData = response?.company || response; 
                const formattedData = {
                    ...apiData,
                    company_category_id: apiData.company_category?.id || '',
                    company_tax_status_id: apiData.company_tax_status?.id || '',
                    subscription_plan_id: apiData.subscription?.subscription_plan?.id || '',
                    subscription_status_id: apiData.subscription?.status?.id || '',
                    id: apiData.id,
                    password: '' 
                };
                setCompanyData(formattedData);
            } catch (error) {
                console.error("Error cargando empresa", error);
                setErrorData("No se pudo cargar la información de la empresa.");
            } finally {
                setLoadingData(false);
            }
        };

        fetchCompany();
    }, [companyId, getCompanyById]);

    if (loadingData) {
        return (
            <div className="d-flex justify-content-center p-5">
                <CSpinner color="primary" />
            </div>
        );
    }

    if (errorData || !companyData) {
        return (
            <div className="p-4">
                <CAlert color="danger">{errorData || "Empresa no encontrada"}</CAlert>
                <button className="btn btn-secondary" onClick={() => navigate('/dashboard/companies')}>Volver</button>
            </div>
        );
    }

    return (
        <FormCompany 
            mode="edit"
            initialData={companyData} // Pasa los datos precargados
            pageTitle={`Editar Empresa: ${companyData.company_name}`}
            breadcrumbTitle="Editar Empresa"
            onSubmitFunc={handleUpdateCompany}
        />
    );
};

export default EditCompanyForAdmin;